$(function () {
  const $calc = $('#emi-calculator');

  if (!$calc.length) { return }

  const locale = $calc.data('locale') || 'en-US';
  const $price = $('#emi-price');
  const $rate = $('#emi-rate');
  const $rateNumber = $('#emi-rate-number');
  const $down = $('#emi-down');
  const $downNumber = $('#emi-down-number');
  const $breakdown = $('#emi-breakdown');
  const $schedule = $calc.find('[data-emi=schedule]');
  const labels = $schedule.data('labels');
  let currency = $price.data('currency');
  let years = parseInt($calc.find('[data-years].active').data('years'), 10);

  function format(value) {
    const digits = currency === 'VND' ? 0 : 2;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency, maximumFractionDigits: digits, minimumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return `${currency} ${Math.round(value).toLocaleString()}`;
    }
  }

  function priceValue() {
    return parseInt(($price.val() || '').replace(/\D/g, ''), 10) || 0;
  }

  // EMI = P * r * (1 + r)^n / ((1 + r)^n - 1), r = monthly rate, n = months
  function emiFor(principal, annualRate, months) {
    const r = annualRate / 12 / 100;
    if (r === 0) { return principal / months }
    const factor = Math.pow(1 + r, months);
    return principal * r * factor / (factor - 1);
  }

  // Month-by-month amortization, grouped into years of 12 months
  function schedule(principal, annualRate, months, emi) {
    const r = annualRate / 12 / 100;
    const years = [];
    let balance = principal;
    for (let month = 1; month <= months; month++) {
      const interest = balance * r;
      const principalPaid = Math.min(emi - interest, balance);
      balance = Math.max(balance - principalPaid, 0);
      const yearIndex = Math.ceil(month / 12) - 1;
      years[yearIndex] = years[yearIndex] || { months: [], interest: 0, principal: 0 };
      years[yearIndex].months.push({ month, interest, principal: principalPaid, balance });
      years[yearIndex].interest += interest;
      years[yearIndex].principal += principalPaid;
    }
    return years;
  }

  function escapeHtml(text) {
    return $('<div>').text(text).html();
  }

  function yearHtml(year, index) {
    const label = (key) => escapeHtml(labels[key].replace('%{year}', index + 1));
    const rows = year.months.map((m) => (
      `<tr><td>${m.month}</td><td>${format(m.interest)}</td><td>${format(m.principal)}</td><td>${format(m.balance)}</td></tr>`
    )).join('');

    return `<div class="emi-year">
      <div class="emi-table-wrapp"><table class="emi-table">
        <thead><tr><th>${label('month')}</th><th>${label('interest_paid')}</th><th>${label('principal_paid')}</th><th>${label('balance')}</th></tr></thead>
        <tbody>${rows}</tbody>
      </table></div>
      <div class="emi-year-total">
        <h4>${label('year_total')}</h4>
        <dl>
          <div><dt>${label('year_spend')}</dt><dd>${format(year.interest + year.principal)}</dd></div>
          <div><dt>${label('interest_pay')}</dt><dd>${format(year.interest)}</dd></div>
          <div><dt>${label('principal_pay')}</dt><dd>${format(year.principal)}</dd></div>
        </dl>
      </div>
    </div>`;
  }

  function calculate() {
    const price = priceValue();
    const rate = parseFloat($rate.val()) || 0;
    const downRate = parseFloat($down.val()) || 0;
    const months = years * 12;
    const down = price * downRate / 100;
    const principal = price - down;
    const emi = principal > 0 ? emiFor(principal, rate, months) : 0;
    const total = emi * months;
    const interest = Math.max(total - principal, 0);

    $calc.find('[data-emi=monthly]').text(format(emi));
    $calc.find('[data-emi=principal]').text(format(principal));
    $calc.find('[data-emi=down]').text(format(down));
    $calc.find('[data-emi=interest]').text(format(interest));
    $calc.find('[data-emi=total]').text(format(total));

    const principalShare = total > 0 ? principal / total * 100 : 100;
    $calc.find('[data-emi-bar=principal]').css('width', `${principalShare}%`);
    $calc.find('[data-emi-bar=interest]').css('width', `${100 - principalShare}%`);

    const yearRows = principal > 0 ? schedule(principal, rate, months, emi) : [];
    $schedule.html(yearRows.map(yearHtml).join(''));

    $calc.data('principal', Math.round(principal));
  }

  function updateFill($range) {
    const min = parseFloat($range.attr('min'));
    const max = parseFloat($range.attr('max'));
    const fill = (parseFloat($range.val()) - min) / (max - min) * 100;
    $range[0].style.setProperty('--fill', `${fill}%`);
  }

  function syncPair($source, $target) {
    const min = parseFloat($source.attr('min'));
    const max = parseFloat($source.attr('max'));
    let value = parseFloat($source.val());
    if (isNaN(value)) { return }
    value = Math.min(Math.max(value, min), max);
    $target.val(value);
    updateFill($rate);
    updateFill($down);
    calculate();
  }

  $price.on('input', function () {
    const value = priceValue();
    this.value = value ? value.toLocaleString(locale) : '';
    calculate();
  });

  $rate.on('input', () => syncPair($rate, $rateNumber));
  $rateNumber.on('input', () => syncPair($rateNumber, $rate));
  $down.on('input', () => syncPair($down, $downNumber));
  $downNumber.on('input', () => syncPair($downNumber, $down));
  $rateNumber.add($downNumber).on('blur', function () {
    $(this).val($(this).is($rateNumber) ? $rate.val() : $down.val());
  });

  $calc.on('click', '[data-years]', function () {
    $calc.find('[data-years]').removeClass('active');
    $(this).addClass('active');
    years = parseInt($(this).data('years'), 10);
    calculate();
  });

  $calc.on('click', '[data-currency]', function () {
    $calc.find('[data-currency]').removeClass('active');
    $(this).addClass('active');
    currency = $(this).data('currency');
    calculate();
  });

  $calc.on('click', '[data-emi-toggle]', function () {
    const open = $breakdown.prop('hidden');
    $breakdown.prop('hidden', !open);
    $(this).attr('aria-expanded', open);
  });

  // Prefill the loan request form with the calculated loan amount and currency
  $calc.on('click', '[data-emi-apply]', function () {
    const principal = $calc.data('principal');
    if (principal > 0) {
      $('#loan-amount_of_money').val(principal).trigger('change').trigger('input');
    }
    $('#loan-currency').val(currency).trigger('chosen:updated').trigger('change');
    const $form = $('#contact-form');
    if ($form.length) {
      $('html, body').animate({ scrollTop: $form.closest('.right-block-carloans').offset().top - 100 }, 400);
    }
  });

  calculate();
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/emi_calculator.js